import { AbstractControl, Validators } from '@angular/forms';
import { QaroniBaseFormsDirective } from '@qaroni-core/directives/qaroni-base-forms/qaroni-base-forms.directive';
import { TimezoneAsyncValidator } from '@qaroni-shared/validators/timezone.validator';

export class WorkplaceAddForm extends QaroniBaseFormsDirective {
  private skeleton = {
    description: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    hasAutomaticChecksClose: [null],
    name: ['', Validators.required],
    timezone: ['', Validators.required, TimezoneAsyncValidator.validate()],
  };

  public form = this.fb.group(this.skeleton);

  constructor() {
    super();
  }

  get name(): AbstractControl {
    return this.form.get('name');
  }

  get description(): AbstractControl {
    return this.form.get('description');
  }

  get email(): AbstractControl {
    return this.form.get('email');
  }

  get hasAutomaticChecksClose(): AbstractControl {
    return this.form.get('hasAutomaticChecksClose');
  }

  get timezone(): AbstractControl {
    return this.form.get('timezone');
  }

  get dirtyValidForm(): boolean {
    return this.form.dirty && this.form.valid;
  }

  get validatedForm(): boolean {
    return this.dirtyValidForm && !this.submitting;
  }
}
